import { inject, Injectable, Type } from '@angular/core';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { IFpLoggerNoiseData } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-data';
import { IFpLoggerNoiseTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-tab-connect-service';
import { FpLoggerNoiseSummaryComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-summary/components/fp-logger-noise-summary/fp-logger-noise-summary.component';
import { FpLoggerNoiseSummaryActionType } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-summary/services/fp-logger-noise-summary/fp-logger-noise-summary.actions';
import { FpLoggerNoiseSummaryStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-summary/services/fp-logger-noise-summary/fp-logger-noise-summary.store';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';
import { Observable } from 'rxjs';

@Injectable()
export class FpLoggerNoiseSummaryConnectService implements IFpLoggerNoiseTabConnectService {
  protected tabStore = inject(FpLoggerNoiseSummaryStore);
  public currentTab = FpLoggerNoiseTabs.Summary;

  public component: Type<unknown> = FpLoggerNoiseSummaryComponent;
  public minimizedComponent: Type<unknown> = FpLoggerNoiseSummaryComponent;

  public localLoading(): Observable<boolean> {
    return this.tabStore.loading$;
  }

  public isActive(tab: FpLoggerNoiseTabs) {
    return this.currentTab === tab;
  }

  public initData(selectedDate: string, selectedData: ILdLogger) {
    this.tabStore.dispatch({
      type: FpLoggerNoiseSummaryActionType.GetData,
      date: selectedDate,
      popupMainData: this.toFpLoggerNoiseData(selectedData),
    });
  }

  public updateData(selectedDate: string, selectedData: ILdLogger) {
    this.tabStore.dispatch({
      type: FpLoggerNoiseSummaryActionType.GetData,
      date: selectedDate,
      popupMainData: this.toFpLoggerNoiseData(selectedData),
    });
  }

  private toFpLoggerNoiseData(data: ILdLogger): IFpLoggerNoiseData {
    return {
      loggerDeployment: data.deployment,
      loggerMeasurement: data.measurement,
    };
  }
}
